import { Stack, Typography } from '@mui/material';
import type { TemplatingContextType } from '@tyro/api';
import { IconButtonWithTooltip } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { AddColumnIcon } from '@tyro/icons';
import type { Dispatch, SetStateAction } from 'react';

interface InsertVariableButtonProps {
  onOpenChange: Dispatch<SetStateAction<boolean>>;
  contextType: TemplatingContextType | undefined;
  isFullScreen?: boolean;
}

export function InsertVariableButton({
  onOpenChange,
  contextType,
  isFullScreen,
}: InsertVariableButtonProps) {
  const { t } = useTranslation(['mail']);

  return (
    <Stack justifyContent="center" alignItems="center">
      <IconButtonWithTooltip
        title={
          contextType
            ? t('mail:insertVariableMail')
            : t('mail:insertVariableTooltipMail')
        }
        placement="top"
        onClick={() => {
          onOpenChange(true);
        }}
        disabled={!contextType}
      >
        <AddColumnIcon />
      </IconButtonWithTooltip>
      {isFullScreen && (
        <Typography variant="caption" fontSize="10px">
          {t('mail:variable')}
        </Typography>
      )}
    </Stack>
  );
}
